import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  IsAuthenticad: boolean = false;
  constructor(private readonly auth: AuthService) {
    this.IsAuthenticad = this.auth.isLoggedIn();
    this.auth.isAuthenticatedChange().subscribe((isAuth) => {
      this.IsAuthenticad = isAuth;
    });
  }

  /** Obtém o ID do utilizador logado */
  getUserId(): string | null {
    if (!this.auth.isLoggedIn()) return null;

    const claims = this.auth.getClaims();
    return (
      claims?.id ||
      claims?.Id ||
      claims?.nameid ||
      claims?.sub ||
      claims?.[
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'
      ] ||
      null
    );
  }

  /** Obtém o nome completo do utilizador logado */
  getUsername(): string | null {
    const claims = this.auth.getClaims();
    const username =
      claims?.username ||
      claims?.userName ||
      claims?.name ||
      claims?.Nome ||
      claims?.unique_name ||
      claims?.['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] ||
      null;
    if (!username) return null;
    return this.formatUsername(username);
  }

  /** Obtém o email do utilizador logado */
  getUserEmail(): string | null {
    const claims = this.auth.getClaims();
    const email =
      claims?.email ||
      claims?.Email ||
      claims?.[
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'
      ] ||
      '';
    return email;
  }

  /** Obtém o telefone do utilizador logado a partir das claims */
  getUserPhone(): string | null {
    const claims = this.auth.getClaims();
    const phone =
      claims?.telefone ||
      claims?.Telefone ||
      claims?.phoneNumber ||
      claims?.PhoneNumber ||
      claims?.mobilephone ||
      claims?.phone ||
      claims?.Phone ||
      claims?.[
        'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/mobilephone'
      ] ||
      null;
    return phone ? String(phone) : null;
  }

  /** Retorna as iniciais do primeiro e último nome do utilizador */
  getUserInitials(): string | null {
    const username = this.getUsername();
    if (!username) return null;

    const parts = username.trim().split(/\s+/);
    if (parts.length === 1) {
      return parts[0].charAt(0).toUpperCase();
    }

    const first = parts[0].charAt(0).toUpperCase();
    const last = parts[parts.length - 1].charAt(0).toUpperCase();

    return first + last;
  }

  /** Retorna todas as claims armazenadas */
  getAllClaims(): Record<string, any> | null {
    return this.auth.getClaims();
  }

  /** Formata o nome do utilizador (por exemplo: "JoaoSilva" -> "Joao Silva") */
  private formatUsername(username: string): string {
    return username.replace(/([a-z])([A-Z])/g, '$1 $2');
  }

  /**
   * Verifica se o perfil do utilizador está completo.
   * @param user Objeto do utilizador
   * @returns true se o perfil estiver completo
   */
  isProfileComplete(user: any): boolean {
    if (!user) return false;

    const requiredFields = [
      'userName',
      'email',
      'dataNascimento',
      'nif',
      'iban',
      'telefone',
    ];

    return requiredFields.every(
      (key) =>
        user[key] !== null &&
        user[key] !== undefined &&
        user[key].toString().trim() !== '',
    );
  }
}
